<template>
  <div class="logo-wrapper">
    <img src="@/assets/logo.png" alt="Logo" class="logo-image" />
  </div>
</template>

<script>
export default {
  name: 'AppLogoDoacao'
}
</script>

<style scoped>
.logo-wrapper {
  display: flex;
  align-items: center;
  justify-content: center; 
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.logo-image {
  /* Tamanho menor padrão quando o menu está retraído */
  height: 20px; 
  width: auto;
  object-fit: contain;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding-left: 0px;
}

/* Quando qualquer ancestral '.sidebar-retatil' sofrer hover, a logo cresce */
.sidebar-retatil:hover :deep(.logo-image) {
  height: 48px;
}
</style>